<div *ngIf="isVisible" class="modal-overlay" (click)="onBackdropClick($event)">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title fw-bold">
          <i class="fa fa-folder me-2"></i>
          {{ modalTitle }}
        </h5>
        <button 
          type="button" 
          class="btn-close"
          (click)="onClose()"
          [disabled]="isSubmitting">
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <form [formGroup]="subcategoryForm" (ngSubmit)="onSubmit()">
          
          <!-- Subcategory Name and Sort Order -->
          <div class="row mb-3">
            <div class="col-md-8">
              <label for="modalSubcategoryName" class="form-label fw-medium">
                Subcategory Name <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                id="modalSubcategoryName"
                formControlName="name"
                [class.is-invalid]="isFieldInvalid('name')"
                placeholder="Enter subcategory name"
                autofocus>
              <div class="invalid-feedback">
                {{ getFieldError('name') }}
              </div>
            </div>
            <div class="col-md-4">
              <label for="modalSortOrder" class="form-label fw-medium">Sort Order</label>
              <input
                type="number"
                class="form-control"
                id="modalSortOrder"
                formControlName="sortOrder"
                [class.is-invalid]="isFieldInvalid('sortOrder')"
                min="0"
                max="999">
              <div class="invalid-feedback">
                {{ getFieldError('sortOrder') }}
              </div>
            </div>
          </div>

          <!-- URL Slug -->
          <div class="row mb-3">
            <div class="col-md-8">
              <label for="modalSlug" class="form-label fw-medium">URL Slug</label>
              <input
                type="text"
                class="form-control"
                id="modalSlug"
                formControlName="slug"
                [class.is-invalid]="isFieldInvalid('slug')"
                placeholder="auto-generated-slug">
              <div class="invalid-feedback">
                {{ getFieldError('slug') }}
              </div>
              <small class="form-text text-muted">Lowercase letters, numbers, and hyphens only</small>
            </div>
            <div class="col-md-4 d-flex align-items-end">
              <div class="form-check form-switch w-100">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="modalIsActive"
                  formControlName="activeFlag">
                <label class="form-check-label fw-medium" for="modalIsActive">
                  Active Status
                </label>
              </div>
            </div>
          </div>

          <!-- Description -->
          <!-- <div class="mb-3">
            <label for="modalDescription" class="form-label fw-medium">Description</label>
            <textarea
              class="form-control"
              id="modalDescription"
              rows="3"
              formControlName="description"
              [class.is-invalid]="isFieldInvalid('description')"
              placeholder="Optional description for this subcategory..."></textarea>
            <div class="invalid-feedback">
              {{ getFieldError('description') }}
            </div>
            <small class="form-text text-muted">Maximum 250 characters</small>
          </div> -->

          <!-- Subcategory Info (Edit Mode Only) -->
          <div *ngIf="isEditMode && subcategory" class="bg-light p-3 rounded mb-3">
            <h6 class="fw-bold mb-2">
              <i class="fa fa-info-circle me-2"></i>Subcategory Information
            </h6>
            <div class="row">
              <div class="col-md-6">
                <small class="text-muted d-block">
                  <strong>ID:</strong> {{ subcategory.id }}
                </small>
                <!-- <small class="text-muted d-block" *ngIf="subcategory.createdDate">
                  <strong>Created:</strong> {{ subcategory.createdDate | date:'MMM dd, yyyy HH:mm' }}
                </small> -->
              </div>
              <div class="col-md-6">
                <small class="text-muted d-block">
                  <strong>Category ID:</strong> {{ categoryId }}
                </small>
                <!-- <small class="text-muted d-block" *ngIf="subcategory.updatedDate">
                  <strong>Last Updated:</strong> {{ subcategory.updatedDate | date:'MMM dd, yyyy HH:mm' }}
                </small> -->
              </div>
            </div>
          </div>

        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <div class="d-flex justify-content-between w-100">
          
          <!-- Left Side - Delete and Toggle Buttons (Edit Mode Only) -->
          <div *ngIf="isEditMode && subcategory">
            <button 
              type="button"
              class="btn btn-sm me-2"
              [class]="subcategory.activeFlag ? 'btn-outline-warning' : 'btn-outline-success'"
              (click)="onToggleStatus()"
              [disabled]="isSubmitting">
              <i class="fa" [class]="subcategory.activeFlag ? 'fa-pause' : 'fa-play'" [class.me-1]="true"></i>
              {{ subcategory.activeFlag ? 'Deactivate' : 'Activate' }}
            </button>
            
            <button 
              type="button"
              class="btn btn-sm btn-outline-danger"
              (click)="onDelete()"
              [disabled]="isSubmitting">
              <i class="fa fa-trash me-1"></i>Delete
            </button>
          </div>
          <div *ngIf="!isEditMode"></div>

          <!-- Right Side - Main Action Buttons -->
          <div>
            <button 
              type="button"
              class="btn btn-outline-secondary me-2"
              (click)="onClose()"
              [disabled]="isSubmitting">
              <i class="fa fa-times me-1"></i>Cancel
            </button>
            
            <button 
              type="button"
              class="btn btn-primary"
              (click)="onSubmit()"
              [disabled]="!isFormValid || isSubmitting">
              <span *ngIf="!isSubmitting">
                <i class="fa fa-save me-1"></i>
                {{ isEditMode ? 'Update' : 'Add' }} Subcategory
              </span>
              <span *ngIf="isSubmitting">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                {{ submitButtonText }}
              </span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div *ngIf="showDeleteConfirm" class="modal-overlay confirmation-overlay" (click)="cancelDelete()">
  <div class="modal-dialog modal-dialog-centered" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header border-0 pb-2">
        <h5 class="modal-title fw-bold text-danger">
          <i class="fa fa-exclamation-triangle me-2"></i>
          Confirm Delete
        </h5>
        <button 
          type="button" 
          class="btn-close" 
          (click)="cancelDelete()">
        </button>
      </div>
      <div class="modal-body">
        <div class="text-center mb-3">
          <i class="fa fa-trash-alt text-danger" style="font-size: 3rem; opacity: 0.7;"></i>
        </div>
        <p class="text-center mb-3">
          Are you sure you want to delete the subcategory 
          <strong>"{{ subcategory?.name }}"</strong>?
        </p>
        <div class="alert alert-warning d-flex align-items-start">
          <i class="fa fa-exclamation-triangle me-2 mt-1"></i>
          <div>
            <strong>Warning:</strong> This action cannot be undone. All products assigned to this subcategory will need to be reassigned to another subcategory.
          </div>
        </div>
      </div>
      <div class="modal-footer border-0 pt-0">
        <button 
          type="button" 
          class="btn btn-outline-secondary"
          (click)="cancelDelete()">
          <i class="fa fa-times me-1"></i>Cancel
        </button>
        <button 
          type="button" 
          class="btn btn-danger"
          (click)="confirmDelete()">
          <i class="fa fa-trash me-1"></i>Delete Subcategory
        </button>
      </div>
    </div>
  </div>
</div>